import { useTheme } from '@mui/material';
import React from 'react';
import Carousel from 'react-material-ui-carousel';

export interface Props {
  children: React.ReactNodeArray;
  isIndicatorShown?: boolean;
}

export const CarouselComponent: React.FC<Props> = (props: Props) => {
  const theme = useTheme();

  return (
    <Carousel
      animation="slide"
      interval={4000}
      indicators={props.isIndicatorShown ?? true}
      indicatorContainerProps={{
        className: 'pr_carousel_container',
        style: { textAlign: 'center' },
      }}
      indicatorIconButtonProps={{
        className: 'pr_carousel_basic',
        style: {
          border: `1px solid ${theme.palette.secondary.main}`,
          color: 'transparent',
          marginLeft: 4,
          marginRight: 4,
          width: 10,
          height: 10,
        },
      }}
      activeIndicatorIconButtonProps={{
        className: 'pr_carousel_active',
        style: {
          border: `1px solid ${theme.palette.secondary.main}`,
          backgroundColor: theme.palette.secondary.main,
          marginLeft: 4,
          marginRight: 4,
          width: 10,
          height: 10,
        },
      }}
      navButtonsProps={{
        className: 'pr_carousel_active',
        style: {
          backgroundColor: theme.palette.grey[500],
          width: 20,
          height: 20,
        },
      }}
    >
      {props.children}
    </Carousel>
  );
};

CarouselComponent.displayName = 'Carousel';

export default CarouselComponent;
